var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7214 3.00302L11.2554 3.00002C7.91135 2.99202 5.00835 5.70902 4.98535 9.00002V14.79C4.98535 15.58 4.88535 16.351 4.45435 17.008L4.16735 17.446C3.73035 18.11 4.20035 19 4.98535 19H19.0154C19.8004 19 20.2694 18.11 19.8334 17.446L19.5464 17.008C19.1164 16.351 19.0154 15.579 19.0154 14.789V9.00102C18.9754 5.70902 16.0654 3.01102 12.7214 3.00302V3.00302Z",
    stroke: "#171A1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C15 19.7956 14.6839 20.5587 14.1213 21.1213C13.5587 21.6839 12.7956 22 12 22C11.2043 22 10.4413 21.6839 9.87868 21.1213C9.31607 20.5587 9 19.7956 9 19",
    stroke: "#171A1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSettingsIcon);
export default __webpack_public_path__ + "static/media/notificationSettingsIcon.4b7b6d3bbb12f21d97def975ce330e55.svg";
export { ForwardRef as ReactComponent };